  <template>
  <div>
    <!-- Add customer modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="createcustomer"
      size="lg"
      ref="createcustomer"
      body-class="bg-white"
      cancel-title="Close"
      cancel-variant="light"
      :ok-title-html="submitted == true ? loaderIcon + 'Save' : 'Save'"
      title="Create Customer"
      @ok="onSubmit($event, 'customer-form')"
      @shown="clearForm()"
      scrollable
      :ok-disabled="submitted"
    >
      <b-form
        id="customer_form"
        data-vv-scope="customer-form"
        class="modal-form-scroll px-3"
        style="overflow-x: hidden; overflow-y: hidden; padding-bottom: 180px"
      >
        <b-row class="mt-3 px-0">
          <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
            <div class="container-fluid">
              <b-alert
                class="alert-transparent alert-danger"
                :show="error_show && this.errors.any()"
              >
                <button
                  type="button"
                  @click="error_show = !error_show"
                  class="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <div
                  v-for="item in errors.items"
                  :key="item.id"
                  v-if="item.scope == 'customer-form'"
                >
                  <p class="fw-semi-bold">{{ item.msg }}</p>
                </div>
              </b-alert>
            </div>
          </b-col>
        </b-row>
        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group
              class="mb-3"
              label="Customer ID"
              label-for="cus_legacy_id"
            >
              <b-form-input
                type="text"
                data-vv-name="customer id"
                name="cus_legacy_id"
                size="sm"
                v-model.trim="field.cus_legacy_id"
                v-validate="'max:50|min:3'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="8">
            <!-- <legend>Basic Details</legend> -->
            <b-form-group
              horizontal
              :label-cols="4"
              class="mb-3 mt-4"
              label="Customer Type"
              label-for="cus_type"
            >
              <b-form-radio-group
                class="mt-1"
                @input="
                  field.cus_display_name =
                    field.cus_type == 2
                      ? field.cus_comp
                      : field.cus_fname + ' ' + field.cus_lname
                "
                id="customer_type"
                name="cus_type"
                data-vv-name="customer type"
                v-model.trim="field.cus_type"
                :options="cus_type"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- customer names for customer update cus_name()-->
        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group
              :label-class="field.cus_type == 1 ? 'required' : ''"
              :label="field.cus_type == 1 ? 'First Name' : 'First Name'"
              label-for="cus_fname"
              class="mb-3"
            >
              <b-form-input
                @input="
                  field.cus_display_name =
                    field.cus_type == 2 ? field.cus_comp : field.cus_fname
                "
                id="cus_fname"
                type="text"
                size="sm"
                v-model.trim="field.cus_fname"
                v-validate="
                  field.cus_type == 1 ? 'required|min:3|max:30' : 'min:3|max:30'
                "
                name="cus_fname"
                data-vv-name="first name"
                placeholder
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group label="Last Name" label-for="cus_lname" class="mb-3">
              <b-form-input
                @input="
                  field.cus_display_name =
                    field.cus_type == 2
                      ? field.cus_comp
                      : field.cus_fname + ' ' + field.cus_lname
                "
                type="text"
                size="sm"
                name="cus_lname"
                data-vv-name="last name"
                v-model.trim="field.cus_lname"
                v-validate="'min:1|max:30'"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- End customer names for customer update cus_comp_name()-->
        <!-- customer company and display name for customer update -->
        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group
              class="mb-3"
              :label-class="field.cus_type == 2 ? 'required' : ''"
              label="Company Name"
              label-for="comp_name"
            >
              <b-form-input
                @input="
                  field.cus_display_name =
                    field.cus_type == 2
                      ? field.cus_comp
                      : field.cus_fname + ' ' + field.cus_lname
                "
                type="text"
                size="sm"
                name="cus_comp"
                v-validate="
                  field.cus_type == 2
                    ? 'required|min:3|max:150'
                    : 'min:3|max:150'
                "
                data-vv-name="company name"
                v-model.trim="field.cus_comp"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group
              label-class="required"
              class="mb-3"
              label="Display Name"
              label-for="cus_display_name"
            >
              <b-form-input
                type="text"
                id="dis_name"
                data-vv-name="display name"
                name="cus_display_name"
                v-model.trim="field.cus_display_name"
                size="sm"
                v-validate="'required|max:150|min:3'"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- End customer company and display name for customer update -->

        <!--  Email and Phone no for customer update -->

        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group label="Email Id" label-for="cus_mail" class="mb-3">
              <b-form-input
                type="text"
                size="sm"
                id="cus_mail"
                v-model.trim="field.cus_mail"
                name="cus_mail"
                data-vv-name="email"
                v-validate="'email:true'"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            lg="6"
            md="6"
            sm="8"
            v-if="org_details.gst_type == 1 && field.vdr_gst_type != 6"
          >
            <b-form-group
              :label="'Place of Supply'"
              label-class="required"
              class="mb-3"
              label-for="place_of_supply"
            >
              <v-select
                :disabled="field.place_of_supply == '97'"
                :clearable="false"
                data-vv-name="place of supply"
                name="place_of_supply"
                id="search-select"
                v-model.trim="field.place_of_supply"
                v-validate="'required'"
                size="sm"
                index="state_id"
                label="state_name"
                :options="$AppDetails.state_list"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row
          style="max-width: 1000px"
          class="mt-3"
          v-if="field.cus_type == 2 && org_details.gst_type == 1"
        >
          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group
              class="mb-3"
              :label="'GST Treatment'"
              label-class="required"
              label-for="cus_gst_type"
            >
              <v-select
                :clearable="false"
                id="search-select"
                v-model.trim="field.cus_gst_type"
                name="gst_treatment"
                index="gst_type_id"
                label="gst_type_name"
                v-validate="'required'"
                data-vv-name="gst treatment"
                size="sm"
                :options="$AppDetails.gst_type_list"
                @input="
                  $event == '6'
                    ? ((field.place_of_supply = '97'),
                      (field.exempt_reason = ''),
                      (field.cus_tax_exempt = 0))
                    : field.place_of_supply == '97'
                    ? (field.place_of_supply = org_details.org_state)
                    : (field.place_of_supply = field.place_of_supply)
                "
              />
              <input
                type="hidden"
                name="cus_gst_type"
                :value="
                  typeof field.cus_gst_type != 'undefined' &&
                  field.cus_gst_type != null
                    ? field.cus_gst_type
                    : ''
                "
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="8" v-if="checkgsttype">
            <b-form-group
              class="mb-3"
              :label="'Gst No'"
              label-class="required"
              label-for="cus_gst_no"
            >
              <b-form-input
                type="text"
                name="Customer GST"
                data-vv-name="gst no"
                size="sm"
                class="form-control"
                @input="getPanState($event)"
                :formatter="inputUpper"
                v-model.trim="field.cus_gst_no"
                v-validate="{
                  required: true,
                  regex:
                    checkgsttype && field.cus_gst_type != '8'
                      ? /^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([Z]{1})([0-9A-Z]{1})+$/
                      : /^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([D]{1})([0-9A-Z]{1})+$/,
                  max: 15,
                }"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="8">
            <b-form-group
              horizontal
              label="Pan No"
              label-for="cus_pan_no"
              class="mb-3"
            >
              <b-form-input
                type="text"
                name="cus_pan_no"
                data-vv-name="pan no"
                size="sm"
                :formatter="inputUpper"
                v-model.trim="field.cus_pan_no"
                v-validate="{ regex: /^([A-Z]{5})([0-9]{4})([A-Z]{1})+$/ }"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row style="max-width: 1000px">
          <b-col cols="6" lg="3" md="5" sm="6" class="pr-2">
            <b-form-group
              :label="'Phone No'"
              label-class="required"
              label-for="phone_no"
              class="mb-2"
            >
              <b-form-input
                type="text"
                id="cus_ph_no_1"
                name="cus_ph_no_1"
                data-vv-name="phone number"
                size="sm"
                v-model.trim="field.cus_ph_no_1"
                v-validate="'required: true|phone'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6" lg="6" md="5" sm="6" class="mt-4 pt-2 pl-2">
            <b-form-group
              label=" "
              label-for="checkbox_is_whatsapp_no"
              class="mb-3"
            >
              <b-form-checkbox
                v-model="field.is_whatsapp_no"
                :value="1"
                :unchecked-value="0"
                type="checkbox"
                id="is_whatsapp_no"
                name="is_whatsapp_no"
                data-vv-name="whatsapp number"
                class="mr-2 cursor_pointer"
                >Is WhatsApp No ?</b-form-checkbox
              >
            </b-form-group>
          </b-col>
        </b-row>
        <!-- End Email and Phone no for customer update -->
        <!-- Whatsapp number checkbox for customer update -->
        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.other-details
            >
              Other details
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="other-details" visible>
          <!--  GST Treatment and currency for customer update -->
          <b-row style="max-width: 1000px">
            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="8"
              v-if="org_details.gst_type == 1 && field.cus_gst_type != 6"
            >
              <b-form-group
                label="Tax Preference"
                label-for="tax_prefernce"
                horizontal
                :label-cols="4"
                class="mb-3"
              >
                <b-form-radio-group
                  class="mt-1"
                  data-vv-name="tax exempt"
                  id="customer_tax_exempt"
                  name="cus_tax_exempt"
                  v-model="field.cus_tax_exempt"
                  :options="taxable_preference"
                  @input="field.exempt_reason = ''"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="8"
              v-if="field.cus_tax_exempt == 1 && field.cus_gst_type != 6"
            >
              <b-form-group
                class="mb-3"
                label-class="required"
                label="Exempt Reason"
                label-for="exempt_reason"
              >
                <b-input-group class="vselect-custom-add">
                  <template slot="append">
                    <b-input-group-text
                      class="vselect-custom-add-icon"
                      v-b-tooltip
                      title="Add Exempt"
                      v-on:click="
                        (excemptmodal = true),
                          callexemptmodal({ value: '', label: '' })
                      "
                      >&#43;</b-input-group-text
                    >
                  </template>
                  <template slot="prepend">
                    <v-select
                      :clearable="false"
                      data-vv-name="exempt reason"
                      size="sm"
                      :options="exempt_reason_list"
                      label="label"
                      index="value"
                      name="exempt_reason"
                      v-validate="'required'"
                      v-model.trim="field.exempt_reason"
                      class="form-vselect"
                    >
                      <template slot="option" slot-scope="option">
                        <div
                          class="d-flex w-100 v-select-option"
                          :title="option.label"
                        >
                          <div class="text-truncate" style="width: 292px">
                            {{ option.label }}
                          </div>
                          <span class="select-hover-block">
                            <span
                              class="la la-edit la-lg float-right mr-2"
                              v-on:click.stop="
                                (excemptmodal = true),
                                  callexemptmodal({
                                    value: option.value,
                                    label: option.label,
                                  })
                              "
                            ></span>
                            <span
                              class="fa fa-trash-o fa-lg float-right mt-2p"
                              v-on:click.stop="
                                (excemptdelete = true),
                                  (method = 'exemptdelete'),
                                  calldeletemodal(option.value)
                              "
                            ></span>
                          </span>
                        </div>
                      </template>
                    </v-select>
                  </template>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row
            style="max-width: 1000px"
            v-if="field.cus_type == 1 && org_details.gst_type == 1"
          >
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                :label="'GST Treatment'"
                class="mb-3"
                label-class="required"
                label-for="cus_gst_type"
              >
                <v-select
                  :clearable="false"
                  id="search-select"
                  v-model.trim="field.cus_gst_type"
                  name="gst_treatment"
                  data-vv-name="gst treatment"
                  v-validate="'required'"
                  index="gst_type_id"
                  label="gst_type_name"
                  size="sm"
                  :options="$AppDetails.gst_type_list"
                  @input="
                    $event == '6'
                      ? ((field.place_of_supply = '97'),
                        (field.exempt_reason = ''),
                        (field.cus_tax_exempt = 0))
                      : field.place_of_supply == '97'
                      ? (field.place_of_supply = org_details.org_state)
                      : (field.place_of_supply = field.place_of_supply)
                  "
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8" v-if="checkgsttype">
              <b-form-group
                :label="'GST No'"
                class="mb-3"
                label-class="required"
                label-for="cus_gst_no"
              >
                <b-form-input
                  type="text"
                  data-vv-name="gst no"
                  name="Customer GST"
                  size="sm"
                  class="form-control"
                  :formatter="inputUpper"
                  @input="getPanState($event)"
                  v-model.trim="field.cus_gst_no"
                  v-validate="{
                    required: true,
                    regex:
                      checkgsttype && field.cus_gst_type != '8'
                        ? /^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([Z]{1})([0-9A-Z]{1})+$/
                        : /^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([D]{1})([0-9A-Z]{1})+$/,
                    max: 15,
                  }"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group label="Pan No" label-for="cus_pan_no" class="mb-3">
                <b-form-input
                  type="text"
                  data-vv-name="pan no"
                  name="cus_pan_no"
                  :formatter="inputUpper"
                  size="sm"
                  v-model.trim="field.cus_pan_no"
                  v-validate="{ regex: /^([A-Z]{5})([0-9]{4})([A-Z]{1})+$/ }"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!--  ID for Person-->
          <b-row style="max-width: 1000px" v-if="field.cus_type == 1">
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                label="Proof Type"
                label-for="cus_proof_id"
                class="mb-3"
              >
                <select v-model="field.cus_proof_id" class="form-control">
                  <option></option>
                  <option value="1">Passport ID</option>
                  <option value="2">Voter ID</option>
                  <option value="3">Driving License ID</option>
                </select>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8" v-if="field.cus_proof_id">
              <b-form-group
                :label="'Proof No'"
                label-class="required"
                class="mb-3"
                label-for="cus_proof_no"
              >
                <b-form-input
                  v-model="field.cus_proof_no"
                  type="text"
                  name="cus_proof_no"
                  data-vv-name="proof no"
                  v-validate="field.cus_proof_id ? 'required|max:50' : ''"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width: 1000px">
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                :label="
                  field.cus_currency != '99' && page == 'create'
                    ? 'Currency and Exchange Rate'
                    : 'Currency'
                "
                label-class="required"
                label-for="cus_currency"
              >
                <b-input-group class="vselect-custom-add">
                  <template slot="append">
                    <b-input-group-text
                      class="vselect-custom-add-icon"
                      v-b-modal.currencymodal
                      @click="
                        currency_detail = {
                          id: '',
                          code: '',
                          symbol: '',
                          name: '',
                          decimal_places: 2,
                          format: 1,
                        }
                      "
                      >&#43;</b-input-group-text
                    >
                  </template>
                  <b-input-group-prepend>
                    <v-select
                      :clearable="false"
                      id="search-select"
                      v-model.trim="field.cus_currency"
                      @input="getPriceListCurrency(field.pricing_hdr_id)"
                      name="currency"
                      data-vv-name="currency"
                      v-validate="'required'"
                      size="sm"
                      index="currency_id"
                      label="currency_name"
                      :options="currency_list"
                    />
                  </b-input-group-prepend>
                </b-input-group>
                <input
                  v-if="field.cus_currency != 99"
                  type="text"
                  name="customer currency"
                  data-vv-name="customer currency"
                  class="form-control mt-2"
                  v-model="field.unit_currency"
                  v-validate="'required|decimal:5'"
                  @blur="roundOff('unit_currency', $event)"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                class="mb-3"
                label="Payment Terms"
                label-for="cus_pymnt_term"
              >
                <v-select
                  :clearable="false"
                  data-vv-name="payment term"
                  id="search-select"
                  v-model.trim="field.cus_pymnt_term"
                  name="pymnt_term"
                  index="pymnt_terms_id"
                  label="term_name"
                  size="sm"
                  :options="paymentterm"
                />
                <input
                  type="hidden"
                  name="cus_pymnt_term"
                  :value="
                    typeof field.cus_pymnt_term != 'undefined' &&
                    field.cus_pymnt_term != null
                      ? field.cus_pymnt_term
                      : ''
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width: 1000px" class="my-4">
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                label="Opening Balance"
                label-for="opening_balance"
                v-if="
                  RoutePermission(false, '', '', 'settings', 'openingbalance')
                "
              >
                <input
                  @blur="roundOff('opening_balance', $event)"
                  class="form-control"
                  type="text"
                  name="opening_balance"
                  data-vv-name="Opening Balance"
                  size="sm"
                  v-model.trim="field.opening_balance"
                  v-validate="'min_value:0|decimal:2'"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="8"
              v-if="
                price_list.length > 0 &&
                enablepricelist.is_price_list_enabled == 1
              "
            >
              <b-form-group
                class="mb-3"
                label="Price List"
                label-for="customer-tag-select"
              >
                <v-select
                  style="width: 100%"
                  label="label"
                  index="value"
                  data-vv-name="price list"
                  class="float-left mb-3 form-vselect"
                  id="search-select"
                  v-model.trim="field.pricing_hdr_id"
                  size="sm"
                  :options="pricelistgenerate"
                >
                  <template slot="option" slot-scope="option">
                    <div
                      class="d-flex w-100 v-select-option"
                      :title="option.label"
                    >
                      <div class="text-truncate" style="width: 100%">
                        {{ option.label }}
                      </div>
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              md="6"
              sm="8"
              v-if="
                cus_settings_details.cus_credit_limit &&
                cus_settings_details.cus_credit_limit.enable == 1
              "
            >
              <b-form-group
                class="mb-3"
                label-for="credit_limit"
                label="Credit Limit"
              >
                <b-input-group
                  :prepend="
                    getDetails(
                      $AppDetails.currency_details,
                      field.cus_currency ||
                        $AppDetails.organization.org_currency,
                      'currency_code'
                    )
                  "
                  class="mb-2 mr-sm-2 mb-sm-0 product_currency"
                >
                  <b-input
                    data-vv-name="credit limit"
                    v-validate="'min_value:0|max_value:100000000000000'"
                    @blur="roundOff('credit_limit', $event)"
                    v-model.trim="field.credit_limit"
                    :class="{ 'form-control': true }"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
              v-b-toggle.additional-details
            >
              Additional details
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="additional-details" visible>
          <b-row style="max-width: 1000px">
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                class="mb-3"
                label="Designation"
                label-for="designation"
              >
                <b-form-input
                  type="text"
                  id="designation"
                  v-model.trim="field.cus_dept"
                  name="cus_dept"
                  data-vv-name="department"
                  size="sm"
                  v-validate="'min:3|max:50'"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                class="mb-3"
                label="Website"
                label-for="cus_website"
              >
                <b-form-input
                  data-vv-name="website"
                  type="text"
                  name="cus_website"
                  size="sm"
                  v-model.trim="field.cus_website"
                  v-validate="'url'"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width: 1000px" v-if="field.cus_type == 2">
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                label="Proof Type"
                label-for="cus_proof_id"
                class="mb-3"
              >
                <select v-model="field.cus_proof_id" class="form-control">
                  <option></option>
                  <option value="1">Passport ID</option>
                  <option value="2">Voter ID</option>
                  <option value="3">Driving License ID</option>
                </select>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8" v-if="field.cus_proof_id">
              <b-form-group
                :label="'Proof No'"
                label-class="required"
                label-for="cus_proof_no"
                class="mb-3"
              >
                <b-form-input
                  v-model="field.cus_proof_no"
                  type="text"
                  data-vv-name="proof no"
                  name="cus_proof_no"
                  v-validate="field.cus_proof_id ? 'required|max:50' : ''"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width: 1000px">
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group label="Role" label-for="cus_role" class="mb-3">
                <b-form-input
                  type="text"
                  data-vv-name="role"
                  name="cus_role"
                  size="sm"
                  v-model.trim="field.cus_role"
                  v-validate="'min:3|max:50'"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                label="Facebook ID"
                label-for="cus_facebook_id"
                class="mb-3"
              >
                <b-form-input
                  data-vv-name="facebook id"
                  name="cus_facebook_id"
                  v-model.trim="field.cus_facebook_id"
                  v-validate="'min:3|max:30'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width: 1000px">
            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                label="Twitter ID"
                label-for="cus_twitter_id"
                class="mb-3"
              >
                <b-form-input
                  data-vv-name="twitter id"
                  name="cus_twitter_id"
                  v-model.trim="field.cus_twitter_id"
                  v-validate="'max:30'"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" lg="6" md="6" sm="8">
              <b-form-group
                label=" "
                label-for="checkbox_portal"
                class="mb-3 mt-4 pt-1"
              >
                <b-form-checkbox
                  :value="1"
                  :unchecked-value="0"
                  type="checkbox"
                  id="cus_portal"
                  name="cus_portal"
                  data-vv-name="customer portal"
                  v-model.trim="field.cus_portal"
                  class="mr-2 cursor_pointer"
                  >Enable Portal</b-form-checkbox
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width: 1000px">
            <b-col cols="12" xs="12" sm="12" lg="12" class="mt-3">
              <b-form-group
                label="Customer Notes"
                label-for="customer-tag-select"
              >
                <b-form-textarea
                  id="note"
                  v-model="field.cus_notes"
                  data-vv-name="customer notes"
                  name="cus_notes"
                  rows="5"
                  value
                  v-validate="'min:3|max:250'"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>

        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
              v-b-toggle.address-details
            >
              Address details
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="address-details" visible>
          <b-row style="max-width: 1000px">
            <!-- Billing Address details tab -->
            <b-col cols="12" lg="6" md="6" sm="8">
              <fieldset class="mt-2">
                <p class="text-primary fw-semi-bold mb-3">Billing Address</p>
                <b-form-group
                  label="Address Line 1"
                  label-for="cus_billing_addr_line_1"
                  class="mb-3"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="billing address line 1"
                    name="cus_addr_line_1[]"
                    v-model.trim="field.cus_billing_addr_line_1"
                    v-validate="'max:200'"
                  />
                </b-form-group>
                <b-form-group
                  label="Address Line 2"
                  label-for="cus_billing_addr_line_2"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="billing address line 2"
                    name="cus_addr_line_2[]"
                    v-model.trim="field.cus_billing_addr_line_2"
                    v-validate="'max:200'"
                  />
                </b-form-group>
                <b-form-group :label="'State'" label-for="cus_billing_state">
                  <v-select
                    :clearable="false"
                    data-vv-name="billing state"
                    name="cus_billing_state"
                    id="search-select"
                    v-model.trim="field.cus_billing_state"
                    size="sm"
                    index="state_id"
                    label="state_name"
                    :options="$AppDetails.state_list"
                  />
                </b-form-group>
                <b-form-group
                  class="mb-3"
                  label="City"
                  label-for="cus_billing_city"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="billing city"
                    name="cus_city[]"
                    v-model.trim="field.cus_billing_city"
                    v-validate="'max:30'"
                  />
                </b-form-group>
                <b-form-group
                  label="Country"
                  label-for="cus_billing_country"
                  class="mb-3"
                >
                  <v-select
                    :clearable="false"
                    id="search-select"
                    name
                    data-vv-name="billing country"
                    v-model.trim="field.cus_billing_country"
                    size="sm"
                    index="country_id"
                    label="country_name"
                    :options="$AppDetails.country_list"
                  />
                </b-form-group>
                <b-form-group
                  label="Pincode"
                  label-for="cus_billing_pincode"
                  class="mb-3"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="pincode"
                    name="cus_pincode[]"
                    v-model.trim="field.cus_billing_pincode"
                    v-validate="'max:10'"
                  />
                </b-form-group>
              </fieldset>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="8">
              <fieldset class="mt-2">
                <p class="text-primary fw-semi-bold mb-3">
                  <b-row>
                    <b-col cols="6">Shipping Address</b-col>
                    <b-col cols="6" class="text-right">
                      <span
                        class="text-primary pb-1 mt-2"
                        @click="copyBilling()"
                        style="cursor: pointer"
                      >
                        <i class="fa fa-arrow-down"></i>
                        Copy billing address
                      </span>
                    </b-col>
                  </b-row>
                </p>
                <b-form-group
                  class="mb-3"
                  label="Address Line 1"
                  label-for="cus_shipping_addr_line_1"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="shipping address line 1"
                    name="cus_addr_line_1[]"
                    v-model.trim="field.cus_shipping_addr_line_1"
                    v-validate="'max:200'"
                  />
                </b-form-group>
                <b-form-group
                  label="Address Line 2"
                  label-for="cus_shipping_addr_line_2"
                  class="mb-3"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="shipping address line 2"
                    name="cus_addr_line_2[]"
                    v-model.trim="field.cus_shipping_addr_line_2"
                    v-validate="'max:200'"
                  />
                </b-form-group>
                <b-form-group
                  :label="'State'"
                  label-for="cus_shipping_state"
                  class="mb-3"
                >
                  <v-select
                    :clearable="false"
                    id="search-select"
                    name="cus_shipping_state"
                    v-model.trim="field.cus_shipping_state"
                    size="sm"
                    index="state_id"
                    label="state_name"
                    data-vv-name="shipping state"
                    :options="$AppDetails.state_list"
                  />
                </b-form-group>
                <b-form-group
                  label="City"
                  label-for="cus_shipping_city"
                  class="mb-3"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="shipping city"
                    name="cus_city[]"
                    v-model.trim="field.cus_shipping_city"
                    v-validate="'max:30'"
                  />
                </b-form-group>
                <b-form-group
                  label="Country"
                  label-for="cus_shipping_country"
                  class="mb-3"
                >
                  <v-select
                    :clearable="false"
                    id="search-select"
                    data-vv-name="shipping country"
                    v-model.trim="field.cus_shipping_country"
                    size="sm"
                    index="country_id"
                    label="country_name"
                    :options="$AppDetails.country_list"
                  />
                </b-form-group>
                <b-form-group
                  label="Pincode"
                  label-for="cus_shipping_pincode"
                  class="mb-3"
                >
                  <b-form-input
                    type="text"
                    size="sm"
                    data-vv-name="shipping pincode"
                    name="cus_pincode[]"
                    v-model.trim="field.cus_shipping_pincode"
                    v-validate="'max:10'"
                  />
                </b-form-group>
              </fieldset>
            </b-col>
          </b-row>
        </b-collapse>

        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
              v-b-toggle.reporting-tags
            >
              Reporting Tags
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="reporting-tags" visible>
          <b-row style="max-width: 1000px">
            <!-- Billing Address details tab -->
            <b-col v-if="reporting_tags.length == 0">
              <p class="text-muted">You've not created any Reporting Tags.</p>
            </b-col>
            <b-col
              v-else-if="
                reporting_tags.filter(
                  (tag) =>
                    (tag.status === '0' && field[tag.tag_column_name] != '') ||
                    tag.status === '1'
                ).length == 0
              "
            >
              <p class="text-muted">
                There are no active reporting tags or you've not created a
                reporting tag yet.You can create/edit reporting tags under
                settings
              </p>
            </b-col>
            <template v-else>
              <b-col
                cols="12"
                lg="5"
                md="6"
                sm="8"
                v-for="(tag, index) in reporting_tags"
                :key="index"
                v-if="tag.status === '1' || show_reporting_tag[index].used"
              >
                <b-form-group
                  :label-for="'tag field' + index"
                  :label="tag.tag_name"
                  label-class="text-truncate"
                  v-if="
                    tag.tag_options.filter(
                      (x) =>
                        (x.is_active == false &&
                          show_reporting_tag[index][tag.tag_column_name] ==
                            x.value) ||
                        x.is_active
                    ).length > 0
                  "
                >
                  <v-select
                    :clearable="
                      field[tag.tag_column_name] != '' &&
                      field[tag.tag_column_name] != null
                    "
                    @input="
                      $event == null ? (field[tag.tag_column_name] = '') : ''
                    "
                    v-model="field[tag.tag_column_name]"
                    index="value"
                    label="label"
                    :options="
                      tag.tag_options.filter(
                        (x) =>
                          (x.is_active == false &&
                            show_reporting_tag[index][tag.tag_column_name] ==
                              x.value) ||
                          x.is_active
                      )
                    "
                    class="form-vselect"
                  >
                    <template slot="option" slot-scope="option">
                      <div
                        class="d-flex w-100 v-select-option"
                        :title="option.label"
                      >
                        <div class="text-truncate" style="width: 100%">
                          {{ option.label }}
                        </div>
                      </div>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </template>
          </b-row>
        </b-collapse>

        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
              v-b-toggle.contact-details
            >
              Contact details
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="contact-details" visible>
          <b-row style="max-width: 1000px">
            <b-col xl="12" lg="12" md="12" sm="12" xs="12" class="pr-1">
              <div class="table-responsive">
                <table
                  class="table table-bordered sales-table last-child-border-none"
                >
                  <thead>
                    <!-- <th style="width:10px">#</th> -->
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Work Phone</th>
                    <th>Mail</th>
                    <th>Designation</th>
                    <th>Department</th>
                    <th></th>
                  </thead>

                  <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                      <td>
                        <b-form-input
                          class="in-bdr"
                          id="contact_fname"
                          v-model.trim="item.cntct_fname"
                          type="text"
                          size="sm"
                          data-vv-name="contact first name"
                          :name="'cntct_fname[' + index + ']'"
                          style="border: none; padding: 5px"
                          v-validate="'max:30'"
                        />
                      </td>
                      <td>
                        <b-form-input
                          id="cntct_lname"
                          v-model.trim="item.cntct_lname"
                          type="text"
                          data-vv-name="contact last name"
                          size="sm"
                          :name="'cntct_lname[' + index + ']'"
                          style="border: none; padding: 5px"
                          v-validate="'max:30'"
                        />
                      </td>
                      <td>
                        <b-form-input
                          id="cntct_no"
                          v-model.trim="item.cntct_no"
                          type="text"
                          size="sm"
                          data-vv-name="contact no"
                          :name="'cntct_no[' + index + ']'"
                          style="border: none; padding: 5px"
                          v-validate="'phone: true'"
                        />
                      </td>
                      <td>
                        <b-form-input
                          id="cntct_mail"
                          v-model.trim="item.cntct_mail"
                          type="text"
                          size="sm"
                          data-vv-name="contact email"
                          :name="'cntct_mail[' + index + ']'"
                          style="border: none; padding: 5px"
                          v-validate="'email:true'"
                        />
                      </td>
                      <td>
                        <b-form-input
                          id="cntct_role"
                          v-model.trim="item.cntct_role"
                          type="text"
                          size="sm"
                          data-vv-name="contact designation"
                          style="border: none; padding: 5px"
                          :name="'cntct_role[' + index + ']'"
                          v-validate="'max:50'"
                        />
                      </td>
                      <td>
                        <b-form-input
                          id="cntct_dept"
                          v-model.trim="item.cntct_dept"
                          type="text"
                          size="sm"
                          data-vv-name="contact department"
                          style="border: none; padding: 5px"
                          :name="'cntct_dept[' + index + ']'"
                          v-validate="'max:50'"
                        />
                      </td>
                      <td>
                        <b-form-group class="text-center">
                          <span>
                            <i
                              class="glyphicon glyphicon-trash mt-2"
                              @click="removeRow(index)"
                            ></i>
                          </span>
                        </b-form-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b-col xl="12" md="12" lg="12" sm="12" xs="12" class="pl-0">
                <span class="text-link fw-semi-bold" @click="addNewRow()"
                  >Add Lines</span
                >
              </b-col>
            </b-col>
          </b-row>
        </b-collapse>

        <template v-if="cus_settings_details.custom_field.length > 0">
          <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
            <b-col>
              <h6
                class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
                v-b-toggle.custom-fields
              >
                Custom fields
                <i class="fa fa-angle-down fw-semi-bold mr-1"></i>
              </h6>
            </b-col>
          </b-row>
          <b-collapse id="custom-fields" visible>
            <b-row style="max-width: 1000px">
              <b-col
                cols="12"
                lg="6"
                md="6"
                sm="8"
                :key="index"
                v-for="(custom_field,
                index) in cus_settings_details.custom_field"
                v-if="
                  custom_field.status == 1 &&
                  custom_field.permissions == 'write'
                "
              >
                <CustomPreview
                  v-on:assigncustomvalue="assigncustomvalue($event)"
                  :custom="custom_field"
                  :disabled="false"
                  :modelname="field[custom_field.field_name]"
                />
                <input
                  type="hidden"
                  :name="custom_field.label_name"
                  v-validate="custom_field.validation"
                  v-model="field[custom_field.field_name]"
                />
              </b-col>
            </b-row>
          </b-collapse>
        </template>
        <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold h6-lg cursor_pointer"
              v-b-toggle.remarks
            >
              Remarks
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="remarks" visible>
          <b-row style="max-width: 1000px">
            <b-col cols="12" lg="10">
              <b-form-group label="Remarks" label-for="cus_internal_notes">
                <b-form-textarea
                  id="note"
                  v-model="field.cus_internal_notes"
                  name="cus_internal_notes"
                  data-vv-name="customer remarks"
                  rows="5"
                  value
                  v-validate="'min:3|max:250'"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
      </b-form>
    </b-modal>
    <TagModal
      v-if="customertags"
      :tag_id="modal_tag_id"
      module="customer"
      v-on:setMultipleAddedRef="getMultipleAddedRef"
    ></TagModal>
    <DeleteDropdown
      v-if="customerdeletetag || excemptdelete"
      id="customer-dropdown-delete"
      content="Are you sure to delete the selected detail ?"
      module="general"
      method="exemptreasondelete"
      v-on:setDropdownDelete="getDropdownDelete"
      :value="deletedropdownid"
    ></DeleteDropdown>
    <!-- create and update currency modal -->
    <CurrencyModal
      :page="'create'"
      :currency_detail="currency_detail"
      @addedCurrency="field.cus_currency = $event"
    ></CurrencyModal>
    <!-- <TagModal :tag_id="modal_tag_id" module="customer"></TagModal> -->
    <ExemptReason
      v-if="excemptmodal"
      :exempt_reason="modal_exempt_reason"
      module="customer"
      v-on:setMultipleAddedRefExempt="getMultipleAddedRefExempt"
    ></ExemptReason>
    <b-modal
      :no-close-on-backdrop="true"
      id="duplicateModal"
      size="md"
      ref="duplicateModal"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      ok-title="Go to Settings"
      @ok="GoSettings"
      v-model="duplicate_modal"
      :hide-header="true"
    >
      <b-form>
        <b-form-group>
          <b-row>
            <b-col lg="12">
              <p class="text-muted mt-3">
                <i class="fa fa-exclamation-circle fa-lg text-warning mr-1"></i>
                The Contact Name
                <span class="fw-semi-bold text-dark">{{
                  field.cus_display_name
                }}</span>
                already exists. Your current settings does not allow you to
                create duplicate contact names. You can change the settings to
                allow this or specify a different name.
              </p>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>
  <!-- script for customer create -->
  <script>
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import TagModal from "@/components/Modal/TagModal";
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import vSelect from "vue-select";
import DeleteDropdown from "@/components/Modal/DeleteDropdown";
import $ from "jquery";
import CurrencyModal from "@/components/Modal/Currency/CurrencyModal"; // to excel export the output
import ExemptReason from "@/components/Modal/ExemptReason";

export default {
  mixins: [notificationMixin],
  name: "",
  components: {
    vSelect,
    CustomPreview,
    TagModal,
    DeleteDropdown,
    CurrencyModal,
    ExemptReason,
  },
  data() {
    return {
      duplicate_modal:false,
      show_reporting_tag: [],
      page: "create",
      customertags: false,
      customerdeletetag: false,
      updatetag: false,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      checked: false,
      error_show: false,
      modal_tag_id: {},
      deletedropdownid: "",
      text: "",
      checkboxes1: "",
      modal_sales_person_id: {},
      modal_exempt_reason: "",
      excemptmodal: false,
      customer_modal_id: "",
      taxable_preference: [
        {
          text: "Taxable",
          value: "0",
        },
        {
          text: "Tax Exempt",
          value: "1",
        },
      ],
      cus_type: [
        {
          text: "Person",
          value: "1",
        },
        {
          text: "Organization",
          value: "2",
        },
      ],
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      field: this.createFreshEventObject(),
      items: [
        {
          cntct_fname: "",
          cntct_lname: "",
          cntct_no: "",
          cntct_mail: "",
          cntct_role: "",
          cntct_dept: "",
        },
      ],
      currency_detail: {
        id: "",
        code: "",
        symbol: "",
        name: "",
        decimal_places: 2,
        format: 1,
      },
      excemptdelete: false,
    };
  },
  methods: {
    GoSettings() {
      this.$router.push({
        name: "CustomerStatement",
      });
    },
    getMultipleAddedRefExempt(ev) {
      if (ev.close) {
        this.excemptmodal = false;
        return;
      }

      this.field.exempt_reason = "";
      this.field.exempt_reason = this.updatedtag_id;
    },
    callexemptmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addexempt");
        this.modal_exempt_reason = val;
      });
    },
    //    roundoff paid amount
    roundOff(field) {
      this.field[field] =
        typeof this.field[field] != undefined &&
        !isNaN(this.field[field]) &&
        this.field[field] != ""
          ? parseFloat(this.field[field]) <= 0 && field == "credit_limit"
            ? ""
            : parseFloat(this.field[field]).toFixed(2)
          : field == "credit_limit"
          ? ""
          : parseFloat(0).toFixed(2);
    },
    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },
    getMultipleAddedRef(ev) {
      if (ev.close) {
        this.customertags = false;
        return;
      }
      var value = this.updatedtag_id;
      if (this.updatetag != true) {
        this.field.cus_tags.push(value);
      }
    },
    calltagmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addTag");
        this.modal_tag_id = val;
      });
    },
    //  call delete dropdown modal
    calldeletemodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "customer-dropdown-delete");
        this.deletedropdownid = val;
      });
    },
    //  to get the json particular value
    getPresentValue(arr, prop, val, field) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][field];
          // alert(hasMatch);
          break;
        }
      }
      return hasMatch;
    },
    getDropdownDelete(ev) {
      if (ev.close) {
        this.customerdeletetag = false;
        this.excemptdelete = false;
        return;
      }
      if (ev == 200) {
        if (this.method == "exemptdelete") {
          var id = this.getPresentValue(
            this.exempt_reason_list,
            "label",
            ev.label,
            "value"
          );
          this.excemptdelete = false;

          this.field.exempt_reason = id;
        }
        // if (this.field.cus_tags != []) {
        //   var index = this.field.cus_tags.indexOf(this.deletedropdownid);
        //   if (index != -1) {
        //     this.field.cus_tags.splice(index, 1);
        //     this.deletedropdownid = "";
        //   }
        // }
      }
    },
    //get pan no
    getPanState(val) {
      this.field.cus_pan_no = val.substr(2, 10);
      //get source supply no
      val = val.substr(0, 2);
      var isNum = /^\d+$/.test(val);
      if (isNum) {
        val = parseInt(val);
        if ((val > 0 && val <= 37) || val == 97) {
          this.field.place_of_supply = val.toString();
        }
      }
    },

    copyBilling() {
      this.field.cus_shipping_addr_line_1 = this.field.cus_billing_addr_line_1;
      this.field.cus_shipping_addr_line_2 = this.field.cus_billing_addr_line_2;
      this.field.cus_shipping_state = this.field.cus_billing_state;
      this.field.cus_shipping_city = this.field.cus_billing_city;
      this.field.cus_shipping_country = this.field.cus_billing_country;
      this.field.cus_shipping_pincode = this.field.cus_billing_pincode;
    },

    onSubmit(evt, scope) {
      evt.preventDefault();

      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.submitted = true;
          let data = JSON.stringify({
            field: this.field,
            items: this.items,
          });
          var cus_name =
            this.field.cus_type == 1
              ? this.field.cus_fname + " " + this.field.cus_lname
              : this.field.cus_comp;

          this.$store
            .dispatch("customer/createList", data)
            .then(() => {
              var message, type;
              if (this.status_code == 200) {
                this.submitted = false;
                this.$emit("setCustomerValue", {
                  id: this.updated_id,
                  cus_name: cus_name,
                  pos: this.field.place_of_supply,
                  tax_exempt: this.field.cus_tax_exempt,
                  cus_pymnt_term: this.field.cus_pymnt_term,
                  cus_gst_no: this.field.cus_gst_no,
                  cus_pan_no: this.field.cus_pan_no,
                  cus_gst_type: this.field.cus_gst_type,
                  cus_currency: this.field.cus_currency,
                  pricing_hdr_id: this.field.pricing_hdr_id,
                  credit_limit: this.field.credit_limit,
                  reportingtag: this.field,
                });

                this.event = this.createFreshEventObject();
                this.$refs.createcustomer.hide();
              } else {
                this.submitted = false;
              }
              if (this.show_modal != "modal") {
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: this.status_message,
                  type: this.status_type,
                  showCloseButton: true,
                });
              }
              if (this.show_modal == "modal") {
                this.duplicate_modal = true;
              }
            })
            .catch(() => {});
        } else {
          // Scroll to error message show
          $(".modal-body").scrollTop(0);
          this.error_show = true;
          // Messenger().post({
          //   extraClasses: this.locationClasses,
          //   message: "Please fill all the required fields",
          //   type: "danger",
          //   showCloseButton: true
          // });
        }
      });
      return false;
    },
    addNewRow() {
      this.items.push({});
    },
    removeRow(index) {
      if (this.items.length > 1) {
        this.items.splice(index, 1);
      }
    },
    clearForm() {
      $("#cus-other-details").removeClass("show");
      this.field.pricing_hdr_id = null;
      this.field.unit_currency = 1;
      this.field.opening_balance = 0.0;
      this.field.credit_limit = "";
      this.field.cus_fname = "";
      this.field.cus_lname = "";
      this.field.cus_comp = "";
      this.field.cus_mail = "";
      this.field.cus_ph_no_1 = "";
      this.field.cus_notes = "";
      this.field.cus_tax_exempt = 0;
      this.field.cus_dept = "";
      this.field.cus_display_name = "";
      this.field.cus_gst_no = "";
      this.field.cus_pan_no = "";
      this.field.cus_billing_addr_line_1 = "";
      this.field.cus_billing_addr_line_2 = "";
      this.field.cus_billing_state = "";
      this.field.cus_billing_city = "";
      this.field.cus_billing_country = "";
      this.field.cus_billing_pincode = "";
      this.field.cus_shipping_addr_line_1 = "";
      this.field.cus_shipping_addr_line_2 = "";
      this.field.cus_shipping_state = "";
      this.field.cus_shipping_city = "";
      this.field.cus_shipping_country = "";
      this.field.cus_shipping_pincode = "";
      this.field.cus_type = 1;
      this.field.cus_role = "";
      this.field.cus_legacy_id = "";
      this.field.cus_website = "";
      this.field.cus_internal_notes = "";
      this.field.cus_billing_addr_type = 1;
      this.field.cus_shipping_addr_type = 2;
      this.field.cus_currency = "99";
      (this.field.cus_gst_type = "5"), (this.field.cus_pymnt_term = "7");
      this.field.cus_portal = "";
      this.field.cus_tags = [];
      this.show_reporting_tag = [];
      for (var i = 0; i < this.cus_settings_details.custom_field.length; i++) {
        if (this.cus_settings_details.custom_field[i].status == 1) {
          this.$set(
            this.field,
            this.cus_settings_details.custom_field[i].field_name,
            this.cus_settings_details.custom_field[i].default_value
          );
        }
      }
    },
    createFreshEventObject() {
      return {
        pricing_hdr_id: null,
        unit_currency: 1,
        opening_balance: 0.0,
        credit_limit: "",
        cus_notes: "",
        cus_tags: [],
        cus_legacy_id: "",
        cus_fname: "",
        cus_lname: "",
        cus_comp: "",
        cus_mail: "",
        cus_ph_no_1: "",
        cus_tax_exempt: 0,
        cus_dept: "",
        cus_display_name: "",
        cus_gst_no: "",
        cus_pan_no: "",
        cus_gst_type: "",
        cus_billing_addr_line_1: "",
        cus_billing_addr_line_2: "",
        cus_billing_state: "",
        cus_billing_city: "",
        cus_billing_country: "",
        cus_billing_pincode: "",
        cus_shipping_addr_line_1: "",
        cus_shipping_addr_line_2: "",
        cus_shipping_state: "",
        cus_shipping_city: "",
        cus_shipping_country: "",
        cus_shipping_pincode: "",
        cus_type: 1,
        cus_role: "",
        cus_website: "",
        cus_internal_notes: "",
        cus_billing_addr_type: 1,
        cus_shipping_addr_type: 2,
        cus_currency: "",
        cus_pymnt_term: "",
        cus_portal: "",
        place_of_supply: "",
        cus_proof_id: "",
        cus_proof_no: "",
        is_whatsapp_no: "",
        exempt_reason: "",
      };
    },
    // cus_name() {
    //   return this.field.cus_type == 1 ? "required" : "";
    // },
    // cus_comp_name() {
    //   return this.field.cus_type == 2 ? "required" : "";
    // }
  },
  created() {
    this.field.place_of_supply = this.org_details.org_state;
    //update to fields for reporting tag field values
    for (var i = 0; i < this.reporting_tags.length; i++) {
      this.show_reporting_tag.push({
        used: "",
        [this.reporting_tags[i].tag_column_name]: "",
      });
      this.$set(this.field, this.reporting_tags[i].tag_column_name, "");
    }

    for (var i = 0; i < this.cus_settings_details.custom_field.length; i++) {
      if (
        this.cus_settings_details.custom_field[i].status == 1 &&
        this.cus_settings_details.custom_field[i].permissions == "write"
      ) {
        this.$set(
          this.field,
          this.cus_settings_details.custom_field[i].field_name,
          this.cus_settings_details.custom_field[i].default_value
        );
      }
    }
    this.initializationMessengerCode();
    store.dispatch("customer/fetchCustomerDetails");
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  watch: {
    checkgsttype: {
      deep: true,
      handler: function (val) {
        if (val == false) {
          this.field.cus_gst_no = "";
        }
      },
    },
  },
  computed: {
    pricelistgenerate() {
      var pricelist = [];
      var field = this.field;
      this.price_list.map((value) => {
        if (
          (value.status == 1 ||
            (value.status == 0 && value.value == field.pricing_hdr_id)) &&
          (value.pricing_type == "fixed_percentage" ||
            ((this.org_details.org_currency == value.currency_id ||
              this.field.cus_currency == value.currency_id) &&
              value.pricing_type == "per_item"))
        ) {
          pricelist.push(value);
        } else if (value.value == field.pricing_hdr_id) {
          field.pricing_hdr_id = null;
        }
      });

      return pricelist;
    },
    checkgsttype() {
      var cus_gst_type =
        typeof this.field.cus_gst_type != "undefined" &&
        this.field.cus_gst_type != null
          ? this.field.cus_gst_type
          : 0;

      return cus_gst_type != "3" && cus_gst_type != "5" && cus_gst_type != "6";
    },
    ...mapState({
      status_code: (state) => state.customer.status_code,
      status_message: (state) => state.customer.status_message,
      status_type: (state) => state.customer.status_type,
      list: (state) => state.customer.list,
      enablepricelist: (state) => state.permission.price_list,
      updated_id: (state) => state.customer.updated_id,
      code: (state) => state.customer.code,
      paymentterm: (state) => state.customer.paymentterm,
      customertaglist: (state) => state.customer.customertaglist,
      message: (state) => state.customer.message,
      price_list: (state) => state.customer.price_list,
      updatedtag_id: (state) => state.customer.updatedtag_id,
      currency_list: (state) => state.customer.currency_list,
      exempt_reason_list: (state) => state.customer.exempt_detail, //get exempt reason in dropdown
      show_modal: (state) => state.customer.show_modal,
    }),
    ...mapGetters(["org_details", "cus_settings_details", "reporting_tags"]),
  },
};
</script>
<style lang="scss" scoped>
.glyphicon {
  vertical-align: top !important;
}
</style>
